import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './Pis.css';
import { fetchInitialData } from "../../fetchData";
import Right from '../../right/Right';
// import QuestionOverlay from '../../qna/common/QuestionOverlay';
import Cookies from "js-cookie";
import Service from '../../service/Service';
import withContext from "../../../withContext";
// import * as actions from '../Actions';
// import * as qactions from '../../qna/Actions';

const service = new Service();

class PisManageReport extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let serverSideData = {};
        this.testId = this.props.params.id;
        let _this = this;
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        if (serverSideData && serverSideData['result']) {
            initialData = serverSideData['result']['test'].filter(function (item) {
                return _this.testId == item.id;
            });
        }
        console.log('initialData -----',initialData)
        this.state = {
            initialData: initialData,
            childIdQuePost: 0,
            isPisPage: true,
            metaTitle: "Pregnancy Checkup Schedule – Tests, Screening, Scans & more",
            metaDescription: [
                { "name": "description", "content": "Prenatal medical care is most important to monitor the health of pregnant woman and baby. Find more about checkups to be done during pregnancy for a healthy baby & You. Get more information about antenatal care at FirstCry Parenting." },
                { "name": "keywords", "content": "prenatal care, pregnancy checkup, medical examination during pregnancy" },
                { "name": "atdlayout", "content": "tools_sp" }
            ]
        };
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var url = global.api_url + "preginspection/getpregnancyinspectiontest";
        let body = JSON.stringify({});
        return fetchInitialData(url, JSON.stringify(header), body);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        console.log(this.state.initialData);
        if (navigator.onLine) {
            if (!this.state.initialData || (this.state.initialData && Object.keys(this.state.initialData).length < 1)) {
                service.showLoader();
                this.pisData();
            } else {
                localStorage.setItem('pisDataReport' + this.testId, JSON.stringify(this.state.initialData));
            }
        } else {
            if (localStorage.getItem('pisDataReport' + this.testId)) {
                this.setState({ initialData: JSON.parse(localStorage.getItem('pisDataReport' + this.testId)) });
            }
            service.hideLoader();
        }
    }

    pisData() {
        var postData = {}
        var url = global.api_ci_url + "Pis/getPisLandingData";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) {
                let _this = this;
                let initialData = json['result']['test'].filter(function (item) {
                    return _this.testId == item.id;
                });
                this.setState({ initialData: initialData });
                localStorage.setItem('pisDataReport' + this.testId, JSON.stringify(initialData));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    upcommingTest(){
        Cookies.set("upCommingtest", "1");
        window.location.href = service.getRedirectUrl("/tools/pregnancy-checkup-schedule/");
        

    }
    AskQnaQuetion() {
        Cookies.set("openAskQue", "MealPlanner");
        window.location.href = service.getRedirectUrl("/qna/questions-answers/");
    }

    render() {
        return (
            <main className="main-container pis-main-container">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools/pregnancy-checkup-schedule")} className="R11_9e">Pregnancy Inspection Schedule</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Manage Reports</span>
                    </div>
                    {this.state.initialData && this.state.initialData[0] && this.state.initialData[0]['title'] &&
                        <h1 className="B24_00" id="skipToH1" tabIndex={0}>{this.state.initialData[0]['title']}</h1>
                    }
                </div>
                <div className="sub-container left pis_details_sub_conterner_360">
                    <div className="data-container left">
                        {this.state.initialData && this.state.initialData[0] &&
                            <div className="manage-reports">
                                <div className="manage-reports-top">
                                    <div className="test-icon left">
                                        <span className="test-icon-bg" data-icon-font="&#xe056;"></span>
                                        <span className="test-icon-sm" data-icon-font="&#xe056;"></span>
                                    </div>
                                    <div className="test-title">
                                        {this.state.initialData[0]['title'] &&
                                            <p className="test-name B16_white">{this.state.initialData[0]['title']}</p>
                                        }
                                        {this.state.initialData[0]['startWeek'] && this.state.initialData[0]['endWeek'] &&
                                            <div className="test-wk">{this.state.initialData[0]['startWeek'] + " - " + this.state.initialData[0]['endWeek'] + " Weeks"}</div>
                                        }
                                    </div>
                                </div>

                                <div className="test-content pie-report-common">
                                    <div className="due-on-cnt">

                                    <span className={(this.state.initialData[0]['dueOn'] && this.state.initialData[0]['dueOn'] != '') ? "due left M13_42" : "noduedate left M13_42"}>Due on</span>
                                    <span className="due-date R13_fc">{(this.state.initialData[0]['dueOn'] && this.state.initialData[0]['dueOn'] != '') ? this.state.initialData[0]['dueOn'] : "Date Not available"}</span>
                                     
                                    {this.state.initialData[0]['status'] == "done" || this.state.initialData[0]['givenOn'] != '' ?
                                        <div><Link to={service.getRedirectUrl(`/tools/pregnancy-checkup-schedule/updateDetails/${this.state.initialData[0]['title'].trim().replace(/\s/g, "_").replace(/\//g, "+")}/${this.testId}`)} className="mark right"><span className="view-det R13_9e">View Details</span></Link></div>
                                        :
                                        <div>
                                        {this.state.initialData[0]['status'] !="upcoming" || this.state.initialData[0].dueOnFlag == 1 ?
                                            <Link to={service.getRedirectUrl(`/tools/pregnancy-checkup-schedule/updateDetails/${this.state.initialData[0]['title'].trim().replace(/\s/g, "_").replace(/\//g, "+")}/${this.testId}`)} className="mark right"><span className="mark-done R13_fc">Mark Done </span></Link>
                                            : ''
                                        }
                                        </div>
                                        
                                    }
                                    </div>
                                    <div className="reminder-cnt">
                                        <span className="due left M13_42">{this.state.initialData[0]['givenOn'] != '' ? "Given On" : "Reminder set for"}</span>
                                        {this.state.initialData[0]['givenOn'] != '' ?
                                            <span className="rem-dt R13_fc takenDate">{this.state.initialData[0]['givenOn']}</span>
                                            :
                                            <span className="rem-dt R13_fc dueDate">{this.state.initialData[0]['reminderDate'] != '' ? this.state.initialData[0]['reminderDate'] : "No Reminder Added."}
                                                <a href={service.getRedirectUrl(`/tools/pregnancy-checkup-schedule/manageReminder/${this.testId}/${this.state.initialData[0]['title'].trim().replace(/\s/g, "_").replace(/\//g, "+")}`)} className="rem-icon" data-icon-font="H"></a>
                                            </span>
                                        }
                                    </div>
                                    <div className="test-text">
                                        <div className="test-txt R14_75">{this.state.initialData[0]['desc'] != '' ? this.state.initialData[0]['desc'] : ''}</div>
                                        <div className="moreless">
                                            <a target="_blank" href={service.getRedirectUrl(this.state.initialData[0]['url'].replace("http://", "https://"))}>Read More</a>
                                            {/* <Link to={service.getRedirectUrl(this.state.initialData[0]['url'].replace("http://", "https://"))}>
                                                <span className="R14_link testtxt-more">Read More -- {this.state.initialData[0]['url']}</span>
                                            </Link> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="test-content_pie-report-common">
                                   <div className="upcomming-test-scans bg_color_one" onClick={()=>this.upcommingTest()}>
                                       <div className="upcomming-content-inner-left">
                                            <h2> Upcomming Tests & Scans</h2>
                                            <p> Tap here to know your upcomming tests</p>
                                            <button type="text"> Check upcomming Tests</button>
                                        </div>
                                       <div className="upcomming-content-inner-right"> 
                                          <div className="right-icons-common calendar-pie">
                                              {/* <img src="../../../../images/Calendar.png" alt="logo"/>*/}
                                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Calendar.png" alt="logo"/>
                                          </div>
                                       </div>
                                   </div>
                                   <a href={service.getRedirectUrl('/tools/my-baby-bump/')}>
                                   <div className="upcomming-test-scans bg_color_two">
                                       <div className="upcomming-content-inner-left">
                                            <h2> Capture your Bumpie every week</h2>
                                            <p> Record changes throughout Pregnancy!</p>
                                            <button type="text"> Capture Bumpie</button>
                                        </div>
                                       <div className="upcomming-content-inner-right"> 
                                          <div className="right-icons-common">
                                              {/* <img src="../../../../images/My_Bumpie.png" alt="logo"/> */}
                                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/My_Bumpie.png" alt="logo"/>
                                          </div>
                                       </div>
                                   </div>
                                   </a>
                                   {/* <a href={service.getRedirectUrl('/online-consultation/')}>
                                   <div className="upcomming-test-scans bg_color_three">
                                       <div className="upcomming-content-inner-left">
                                            <h2> DocConnect</h2>
                                            <p> Get connected to verified Doctors 24*7</p>
                                            <button type="text"> Consult Now</button>
                                        </div>
                                       <div className="upcomming-content-inner-right"> 
                                          <div className="right-icons-common">
                                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/DocConnect.png" alt="logo"/>
                                          </div>
                                       </div>
                                   </div>
                                   </a> */}
                                </div>
                                <div className="preg-ask-que" onClick={() =>  this.AskQnaQuetion()} id="devaskQuestion">
                                    <div data-icon-font="H" className="icon pencil"></div>
                                    <span className="B14_white dev_ask_question">ASK A QUESTION</span>
                                </div>
                            </div>
                        }
                        {(!this.state.initialData || this.state.initialData.length < 1) &&
                            <div className="manage-reports"></div>
                        }
                    </div>
                </div>
                
                <Right url={this.props.location.pathname} />
            </main>
        )
    }
}

export default withContext(PisManageReport);
